export default __webpack_public_path__ + "static/media/monitor.6db3cb63.svg";